import MdCheckbox from "./MdCheckbox"

const MdCheckboxPlugin = {
  install(app) {
    app.component(MdCheckbox.name, MdCheckbox)
  },
}

export default MdCheckboxPlugin
